import React from 'react';
import { View } from '../types';
import Logo from './Logo';

interface NavbarProps {
  currentView: View;
  onNavigate: (view: View) => void;
}

const Navbar: React.FC<NavbarProps> = ({ currentView, onNavigate }) => {
  const isAdmin = currentView === 'admin' || currentView === 'admin-login';
  const isHome = currentView === 'home';

  const goHome = () => {
    window.location.hash = '';
    onNavigate('home');
  };

  return (
    <nav className="sticky top-0 z-50 bg-brand-night/90 backdrop-blur-md border-b border-white/5 text-white">
      <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer group" onClick={goHome}>
          <Logo className="w-10 h-10 rounded-xl group-hover:scale-105 transition-transform" />
          <div className="hidden sm:block">
            <span className="font-display font-semibold uppercase tracking-wide text-lg block leading-none">Congresso de Homens</span>
            <span className="text-[10px] text-brand-amber font-bold tracking-[0.3em] uppercase">IPCC • 2026</span>
          </div>
        </div>

        <div className="flex items-center gap-6">
          {isAdmin ? (
            <button
              onClick={goHome}
              className="text-sm font-black text-brand-amber hover:text-white transition-colors uppercase tracking-widest"
            >
              ← Voltar ao Site
            </button>
          ) : (
            <>
              {isHome && (
                <div className="hidden md:flex items-center gap-7 text-[11px] font-bold uppercase tracking-[0.2em] text-white/60">
                  <a href="#preletores" className="hover:text-white transition-colors">Preletores</a>
                  <a href="#programacao" className="hover:text-white transition-colors">Programação</a>
                  <a href="#levar" className="hover:text-white transition-colors">O que levar</a>
                  <a href="#local" className="hover:text-white transition-colors">Local</a>
                </div>
              )}
              <button
                onClick={() => onNavigate('registration')}
                className="bg-brand-amber text-brand-night px-6 py-3 rounded-xl text-sm font-black uppercase tracking-wider hover:bg-white transition-all shadow-lg shadow-brand-amber/20 active:scale-95"
              >
                Fazer Inscrição
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
